import type { Components, Theme } from "@mui/material";

export const loadingButtonTheme: Components<Theme>["MuiLoadingButton"] = {
  defaultProps: {
    variant: "contained",
  },
};
